import React from 'react';

export interface StatusInfoCellProps {
  label: string;
  color?: string | null;
}

export const StatusInfoCell: React.FC<StatusInfoCellProps> = ({
  label,
  color
}) => {
  return (
    <div className="flex items-center space-x-3">
      {color && (
        <div 
          className="w-4 h-4 rounded-full border border-border-primary"
          style={{ backgroundColor: color }}
        />
      )}
      <span className="text-sm font-medium text-text-primary">
        {label}
      </span>
    </div>
  );
};
